export function baseify(string = '') {
  return (
    string &&
    string
      .replace(/^[0-9]{4} /, '')
      .replace(/ (N|NØ|Ø|SØ|S|SV|V|NV|C|K)$/, '')
      .trim()
  );
}

export function slugify(string = '') {
  return (
    string &&
    baseify(string)
      .toLowerCase()
      .replace(/æ/g, 'ae')
      .replace(/ø/g, 'oe')
      .replace(/å/g, 'aa')
      .replace(/ö/g, 'o')
      .replace(/ä/g, 'a')
      .replace(/ü/g, 'u')
      .replace(/[^a-z]+/g, '-')
      .replace(/-+/g, '-')
      .replace(/(^-+|-+$)/g, '')
  );
}
